import { AnyAppEvent, AppEvent } from "../appEvent.types";

const eventName = "equipment-request-answer" as const;

export type EquipmentRequestAnswerEventData = {
  status: "accept" | "refuse";
  eventId: string;
};
export type EquipmentRequestAnswerEvent = AppEvent<
  typeof eventName,
  EquipmentRequestAnswerEventData
>;

export const isEquipmentRequestAnswerEvent = (
  event: AnyAppEvent
): event is EquipmentRequestAnswerEvent => event.name === eventName;

export { eventName as equipmentRequestAnswer };
